import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import moment from "moment";
export default (context) => {
    return {
      config: {
        resource: "admTracking",
        pageSize: 40,
        list: false,
        remapRow: (form, data, action) => {
          form.grado = form.sectionName.label
          form.user = form.userId.label
          form.dateFrom = moment(form.dateFrom).format('YYYY-MM-DD HH:mm')
          form.masterName = action === "create" && context.props.userAdmin.role === '5' ? (context.props.userAdmin.name + ' ' + context.props.userAdmin.last) : form.masterId.label
          return form
        }
      },
  
      actions: {
        create: true,
        edit: true,
        delete: true,
        print: true,
        export: true,
        search: true
      },
  
      filter: {
        fields: [
          {
            name: "periodId",
            value: { value: "0", label: "Actual" },
            type: "select",
            label: "Periodo",
            opts: {
              style: 'float-label',
              path: "/admPeriod/get?pick=true"
            }
          },
          {
            name: "superSectionId",
            value: null,
            type: "select",
            label: "Grado",
            opts: {
              style: 'float-label',
              path: "/admSuperSection/get?pick=true"
            }
          },
          {
            name: "sectionId",
            value: "",
            type: "select",
            label: "Sección",
            parent: "superSectionId",
            opts: {
              style: 'float-label',
              path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
            }
          },
          {
            name: "userId",
            value: "",
            type: "select",
            label: "Alumno",
            rules: 'required',
            parent: "sectionId",
            opts: {
              style: 'float-label',
              searchOnline: true,
              withImg: true,
              path: () => { return "/admStudent/get?pick=true&sectionId=" + context.state.formFilter.sectionId }
            }
          },
          {
            type: "daterange"
          },
          {
            name: "type",
            value: "commitment",
            type: "hidden",
          }
        ],
        buttons: [
          {
            label: 'Aplicar filtro',
            renderIf: (ctx) => { return ctx.state.periodId || ctx.state.superSectionId || ctx.state.userId || ctx.state.from || ctx.state.to },
            onClick: (ctx) => { ctx.btnAction('filter') }
          }
        ]
      },

      form: {
        remapOne: (r) => {
          if (r.status >= 0) {
            r.data.periodId = { value: r.data.periodId, label: r.data.periodName }
            r.data.gradeName = { value: r.data.gradeName, label: r.data.gradeName }
            r.data.sectionName = { value: r.data.sectionName, label: r.data.sectionName }
            r.data.userId = { value: r.data.userId, label: r.data.userName }
            r.data.masterId = { value: r.data.masterId, label: r.data.masterName }
          }
          return r
        },
        setValuesBeforePost: (v) => {
          v.values1.map(e => {
            e.selected = true
            e.ID = e.value
            e.name = e.label
            delete e.desc
            delete e.id
            delete e.img
            delete e.value
            delete e.label
            delete e.consecuencias
            return e
          })

          v.sectionName = v.sectionName.value
          v.userId = v.userId.value
          v.masterId = context.state.idItemSelected ? v.masterId.value : (context.props.userAdmin.role === '5' ? context.props.userAdmin.ID : v.masterId.value)

          delete v.flags
          delete v.btn1
          return v
        },
        fields: [
          {
            name: "type",
            value: "commitment",
            type: "hidden",
          },
          
          {
            col: 4,
            name: "periodId",
            value: { value: "0", label: "Actual" },
            type: "select",
            label: "Periodo",
            rules: 'required',
            opts: {
              style: 'float-label',
              path: "/admPeriod/get?pick=true"
            },
            disabled: () => { return context.state.idItemSelected ? true : false }
          },
          {
            col: 4,
            name: "gradeName",
            value: "",
            type: "select",
            label: "Grado",
            rules: 'required',
            opts: {
              style: 'float-label',
              path: "/admSuperSection/get?pick=true"
            },
            disabled: () => { return context.state.idItemSelected ? true : false }
          },
          {
            col: 4,
            name: "sectionName",
            value: "",
            type: "select",
            label: "Sección",
            rules: 'required',
            parent: 'gradeName',
            opts: {
              style: 'float-label',
              path: () => { return "/admSection/get?pick=true&parentId=" + context.state.form.gradeName },
              setOutput: v => v,
            },
            disabled: () => { return context.state.idItemSelected ? true : false }
          },
          {
            col: 6,
            name: "userId",
            value: "",
            type: "select",
            label: "Alumno",
            rules: 'required',
            parent: 'sectionName',
            opts: {
              style: 'float-label',
              searchOnline: true,
              withImg: true,
              path: () => { return "/admStudent/get?pick=true" + (context.state.form.sectionName ? "&sectionId=" + context.state.form.sectionName.value : "") },
              setOutput: v => v,
            },
            disabled: () => { return context.state.idItemSelected ? true : false }
          },
          {
            col: 6,
            name: "masterId",
            value: "",
            type: "select",
            label: "Profesor",
            rules: 'required',
            opts: {
              style: 'float-label',
              searchOnline: true,
              withImg: true,
              path: () => { return "/admStaff/get?pick=true" },
              setOutput: v => v
            },
            renderIf: () => { return context.props.userAdmin.role !== '5' }
          },
          {
            col: 6,
            name: "dateFrom",
            value: "",
            type: "date",
            label: "Fecha inicio",
            rules: 'required',
            opts: {
              style: 'float-label',
            },
          },
          {
            col: 6,
            name: "dateTo",
            value: "",
            type: "date",
            label: "Fecha fin",
            rules: 'required',
            opts: {
              style: 'float-label',
            },
          },
          {
            col: 12,
            name: "values1",
            value: "",
            type: "select",
            label: "Valor relacionado",
            rules: 'required',
            opts: {
              style: 'float-label',
              isMulti: true,
              path: () => { return "general/getlist/trackingValues1" },
              remap: (r) => {
                return {
                  data: {
                    Results: r.data.map(e => {
                      e.ID = e.id
                      return e
                    })
                  },
                  msg: r.msg,
                  status: r.status
                }
              },
              setOutput: v => v
            }
          },
          {
            col: 12,
            name: "tab-1",
            value: false,
            type: "collapsible",
            label: "Motivo del acuerdo",
            childs: [
              {
                col: 12,
                name: "note1",
                value: "",
                type: "editor",
                label: "Motivo del acuerdo",
                rules: 'required'
              }
            ]
          },
          {
            col: 12,
            name: "tab-2",
            value: false,
            type: "collapsible",
            label: "Compromiso de parte del estudiante",
            childs: [
              {
                col: 12,
                name: "note2",
                value: "",
                type: "editor",
                label: "Compromiso de parte del estudiante",
                rules: 'required'
              }
            ]
          },
          {
            col: 12,
            name: "tab-3",
            value: false,
            type: "collapsible",
            label: "Compromiso de parte del docente",
            childs: [
              {
                col: 12,
                name: "note3",
                value: "",
                type: "editor",
                label: "Compromiso de parte del docente",
                rules: 'required'
              }
            ]
          },
          {
            col: 12,
            name: "tab-4",
            value: false,
            type: "collapsible",
            label: "Consecuencias Positivas",
            childs: [
              {
                col: 12,
                name: "note4",
                value: "",
                type: "editor",
                label: "Consecuencias Positivas",
                rules: 'required'
              }
            ]
          },
          {
            col: 12,
            name: "tab-5",
            value: false,
            type: "collapsible",
            label: "Consecuencias Negativas",
            childs: [
              {
                col: 12,
                name: "note5",
                value: "",
                type: "editor",
                label: "Consecuencias Negativas",
                rules: 'required'
              }
            ]
          },
          {
            col: 12,
            name: "tab-6",
            value: false,
            type: "collapsible",
            label: "Comentarios de la revisión del compromiso",
            childs: [
              {
                col: 12,
                name: "note6",
                value: "",
                type: "editor",
                label: "Comentarios de la revisión del compromiso"
              }
            ]
          },
  
          {
            col: 12,
            name: "dueDate",
            value: "",
            type: "date",
            label: "Fecha de Seguimiento",
            opts: {
              style: 'float-label',
            },
          },

          {
            col: 4,
            colxs: 4,
            name: "file1",
            value: "",
            type: "dropzone",
            label: "Adjunto 1",
            opts: {
              path: ()=> "admTracking/file"
            }
          },
          {
            col: 4,
            colxs: 4,
            name: "file2",
            value: "",
            type: "dropzone",
            label: "Adjunto 2",
            opts: {
              path: ()=> "admTracking/file"
            }
          },
          {
            col: 4,
            colxs: 4,
            name: "file3",
            value: "",
            type: "dropzone",
            label: "Adjunto 3",
            opts: {
              path: ()=> "admTracking/file"
            }
          },
          {
            col: 12,
            name: "bookings",
            value: null,
            type: "hidden",
            label: ""
          },
          {
            col: 12,
            name: "userName",
            value: "",
            type: "hidden",
            label: ""
          },
          {
            col: 12,
            label: "Descargar PDF",
            name: "Descargar PDF",
            value: "commitment",
            type: "button",
            onClick: () => {
              context.props.setLoader(true)
              _axios
                .get('admTracking/pdf/' + context.state.idItemSelected)
                .then(r => {
                  if (r.status >= 0) {
                    window.URL = window.URL || window.webkitURL;
                    var xhr = new XMLHttpRequest(), a = document.createElement('a'), file;
                    xhr.open('GET', r.data.url, true);
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                      file = new Blob([xhr.response], { type : 'application/octet-stream' });
                      a.href = window.URL.createObjectURL(file);
                      a.download = r.data.filename;  
                      a.click();
                    };
                    xhr.send();
                  }
                  NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                  context.props.setLoader(false)
                }).catch(e => {
                  context.props.setLoader(false)
                })
            },
            renderIf: () => { return context.state.idItemSelected },
          }
        ]
      },
  
      columns: [
        {
          Header: "ID",
          accessor: "ID"
        },
        {
          Header: "Alumno",
          accessor: "user"
        },
        {
          Header: "Grado",
          accessor: "grado"
        },
        {
          Header: "Fecha",
          accessor: "dateFrom",
          isDate: true
        },
        {
          Header: "Profesor",
          accessor: "masterName"
        }
      ]
    }
  }